module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/house-on-hill-1400d0fec6acbe4eb1da1654e6b3740e.svg";